export enum ReceptionAttribute {
  Perfect = 882,
  Plus = 883,
  Negative = 884,
  Error = 885,
}
